import { defineAction } from '~/prix'
import { z } from 'zod'
import emergencyDispatchCreateAction from './emergencyDispatchCreate.action.json' with { type: 'json' }
import { emergencyDispatchCreateInputObject } from '../emergencyDispatchObject'

const emergencyDispatchCreateDefinition = defineAction({
  ...emergencyDispatchCreateAction,

  input: emergencyDispatchCreateInputObject,
  output: z.object({
    id: z.string().uuid(),
    code: z.number().int().positive(),
  }),
})

export default emergencyDispatchCreateDefinition
